export enum Role {
	Student = "_STUDENT",
	Teacher = "_TEACHER",
	Parent = "_PARENT",
	Admin = "_ADMIN",
	Owner = "_OWNER"
}
